import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import PageHeader from '../components/PageHeader'
import PlantaMigracion from './PlantaMigracion'
import CargaMasiva from './CargaMasiva'
import { PanelCargaSap } from '../components/compras/ImportadorSap'

// Operaciones > Carga masiva: every bulk load in one place, the same way -- simulate, compare with what exists,
// apply: fabrication orders (work orders; function migrar_monday), units and partes (Mantenimiento; its role) from
// monday's exports, and SAP's export of purchase orders and suppliers (purchasing and admin).
// The tab lives in the address (?tipo=).
const TIPOS = ['ot', 'unidades', 'partes', 'sap']

export default function CargasMasivas() {
  const { t } = useTranslation('operations')
  const { t: tc } = useTranslation('compras')
  const { user } = useAuth()
  const roles = user?.roles || (user?.role ? [user.role] : [])
  const puedeSap = roles.includes('admin') || roles.includes('purchaser')
  const visibles = TIPOS.filter(k => k !== 'sap' || puedeSap)
  const [sp, setSp] = useSearchParams()
  const tipo = visibles.includes(sp.get('tipo')) ? sp.get('tipo') : 'ot'
  return (
    <div className="p-8">
      <div className="mb-6"><PageHeader title={t('cargas.titulo')} subtitle={t('cargas.subtitulo')} /></div>
      <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5 mb-5">
        {visibles.map(k => (
          <button key={k} type="button" onClick={() => setSp({ tipo: k }, { replace: true })}
            className={`px-4 py-1.5 rounded-md text-sm font-medium ${tipo === k ? 'bg-gray-900 text-white' : 'text-gray-500 hover:text-gray-900'}`}>
            {t(`cargas.tipos.${k}`)}
          </button>
        ))}
      </div>
      {tipo === 'ot' ? <PlantaMigracion key="ot" />
        : tipo === 'sap' ? <PanelCargaSap key="sap" t={tc} />
        : <CargaMasiva key={tipo} tipo={tipo} />}
    </div>
  )
}
